<template>
  <div id="app">
    <transition :name="transitionName" v-if="iscatch">
      <keep-alive :include="keepAliveList">
        <router-view :class="[isIosPageMove === '0' ? 'routers' : 'routers-no']"/>
      </keep-alive>
    </transition>
    <!--    <router-view v-if="!iscatch"/>  -->
  </div>
</template>

<script>
// import wx from 'weixin-js-sdk' // 引入微信js-sdk
import {setItem, getItem} from "@/utils/auth";

export default {
  name: 'App',
  data() {
    return {
      transitionName: '',
      iscatch: true,
      // keepAliveList:['iotdealerhome','iotdealerequ','app-index','app-weather','app-personal']
      keepAliveList: ['iotdealerhome', 'iotdealerequ', 'LOGINAPP', 'REGISTERAPP', 'FINDPASSAPP',],
      iTime: null,
      isIosPageMove: null
    }
  },
  mounted() {
    document.addEventListener('touchmove', function (event) {
      setItem('isIosPageMove', '1')
      // event.preventDefault()
    })
  },
  watch: {
    //使用watch 监听$router的变化
    $route(to, from) {
      if (to.meta.iscatch) {
        this.iscatch = to.meta.iscatch
      } else {
        this.iscatch = false
      }
      const isIosPageMove = getItem('isIosPageMove')
      // // 判断是否侧滑 0不是 1是
      if (isIosPageMove === '0') {
        //如果to索引大于from索引,判断为前进状态,反之则为后退状态
        if (to.meta.index > from.meta.index) {
          //设置动画名称
          this.transitionName = "slide-left";
        } else {
          this.transitionName = "slide-right";
        }
      } else {
        this.transitionName = "";
      }
    },
  },
  created() {
    if (LocalStorage.get('store')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(LocalStorage.get('store'))
        )
      )
    }
    window.addEventListener("beforeunload", () => {
      LocalStorage.set('store', JSON.stringify(this.$store.state))
    })
  }
}
</script>

<style type="text/css">
@import './assets/style/common.css';
@import './assets/style/van.less';

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 40px;*/
}

.routers {
  position: absolute;
  width: 100%;
  transition: all .5s ease;
  top: 0;
  bottom: 0;
  margin: 0 auto;
}

.routers-no {
  /*position: absolute !important;*/
  width: 100%;
  height: 100%;
  /*top: 0;*/
  /*bottom: 0;*/
  margin: 0 auto;
  will-change: transform;
  backface-visibility: hidden;
}

/*.slide-left-enter, .slide-right-leave-active {*/
/*  opacity: 0;*/
/*  -webkit-transform: translate3d(100%, 0, 0);*/
/*  transform: translate3d(100%, 0, 0);*/
/*  background: black;*/
/*}*/

/*.slide-left-leave-active, .slide-right-enter {*/
/*  opacity: 0;*/
/*  -webkit-transform: translate3d(-100%, 0,0);*/
/*  transform: translate3d(-100%,0, 0);*/
/*  background: black;*/
/*}*/


.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  height: 100%;
  will-change: transform;
  transition: all 500ms;
  position: absolute !important;
  backface-visibility: hidden;
  perspective: 1000;
}

>>> .slide-enter-active, .slide-leave-active {
  transition: all 1s ease;
  position: absolute;
}

.slide-right-enter, .slide-right-enter-active {
  animation: bounce-left-in 500ms;
}

.slide-right-leave-active {
  animation: bounce-left-out 500ms;
}

.slide-left-enter, .slide-left-enter-active {
  animation: bounce-right-in 500ms;
}

.slide-left-leave-active {
  animation: bounce-right-out 500ms;
}

@keyframes bounce-right-in {
  0% {
    transform: translate3d(100%, 0, 0);
  }
  100% {
    transform: translate3d(0px, 0, 0);
  }
}

@keyframes bounce-right-out {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(-100%, 0, 0);
  }
}

@keyframes bounce-left-in {
  0% {
    transform: translate3d(-100%, 0, 0);
  }
  100% {
    transform: translate3d(0px, 0, 0);
  }
}

@keyframes bounce-left-out {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(100%, 0, 0);
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue